import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sequence-detail-workflow-canvas-branches-dash-right",
  "use": "icon-sequence-detail-workflow-canvas-branches-dash-right-usage",
  "viewBox": "0 0 238 54",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 238 54\" fill=\"none\" id=\"icon-sequence-detail-workflow-canvas-branches-dash-right\">\n  <path d=\"M0.687491 0.0644531V37.7589C0.687491 42.1772 4.26921 45.7589 8.68749 45.7589H228.688C233.106 45.7589 236.687 49.3406 236.687 53.7589L236.687 89.994\" stroke=\"#98A1B3\" stroke-dasharray=\"8 4\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol